import {TemplatePortal} from '@angular/cdk/portal';
import {CommonModule} from "@angular/common";
import {ChangeDetectionStrategy, Component, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {SidenavService} from 'src/app/core/services/sidenav.service';
import {MenuPanelComponent} from './menu-panel/menu-panel.component';
import {IMenu} from 'src/app/core/models/menu.model';
import { Observable } from 'rxjs';
import { Ability } from '@casl/ability';
import { ElaborazioneService } from 'src/app/modules/elaborazioni/elaborazione.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MenuPanelComponent,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  @Input() menu?: IMenu;
  constructor(
    public sidenavService: SidenavService,
    private vcf: ViewContainerRef,
    public readonly elaborazioneService: ElaborazioneService,
    private ability: Ability,
  ) {
  }

  openPanel(templateRef: TemplateRef<any>) {

    this.menu = this.filterMenu(this.menu, this.ability);

    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal, 'start');
  }

  filterMenu(menu:any, ability:any) {
  return menu?.filter((el:any) => {

    const hasPermission = ability.can('enabled', el.name);

    if (el.subMenu && hasPermission) {
      el.subMenu = this.filterMenu(el.subMenu, ability);
    }

    return hasPermission;
  });
}
}
